// API 接口配置
export const API_CONFIG = {
  loginCheck: '//i.gamersky.com/api/logincheck',
  userLogin: '//i.gamersky.com/api/userlogin',
  userLogout: '//i.gamersky.com/api/userlogout',
  verifyExpiration: '//i.gamersky.com/api/verifyexpiration',
  getNotifyCount: '//notify.gamersky.com/api/getnotifycount',
  setReadAll: '//notify.gamersky.com/api/setreadall',
  captchaGet: '//code.gamersky.com/captcha/get',
  captchaCheck: '//i.gamersky.com/captcha/check',
  sendMessage: '//i.gamersky.com/captcha/sendmessage',
  smsRegister: '//i.gamersky.com/captcha/register'
}

// MQTT 配置
export const MQTT_CONFIG = {
  host: 'mqttd.gamersky.com',
  portHttps: 8084,
  portHttp: 8083
}

// Cookie 域名配置
export const COOKIE_DOMAIN = '.gamersky.com'

// 默认头像
export const DEFAULT_AVATAR = '//image.gamersky.com/avatar/original/game/game001.jpg'

// 默认热门搜索词
export const DEFAULT_HOT_SEARCH_WORDS = [
  { name: '生化危机9：安魂曲', linkName: '生化危机9安魂曲' },
  { name: '杀戮尖塔2', linkName: '杀戮尖塔2' },
  { name: '零：红蝶 重制版', linkName: '零红蝶重制版' },
  { name: '怪物猎人物语3：命运双龙', linkName: '怪物猎人物语3命运双龙' },
  { name: '毒液突击队', linkName: '毒液突击队' },
  { name: '仁王3', linkName: '仁王3' },
  { name: '宝可梦Pokopia', linkName: '宝可梦Pokopia' },
  { name: '勇者斗恶龙7：重制版', linkName: '勇者斗恶龙7重制版' },
  { name: '失落星船：马拉松', linkName: '失落星船：马拉松' },
  { name: '无畏契约', linkName: '无畏契约' }
]

// 导航链接
export const NAV_LINKS = [
  { name: '单机游戏', url: 'https://www.gamersky.com/pcgame/' },
  { name: '网络游戏', url: 'https://ol.gamersky.com/' },
  { name: '电视游戏', url: 'https://tv.gamersky.com/' },
  { name: '手机游戏', url: 'https://shouyou.gamersky.com/' },
  { name: '动漫星空', url: 'https://acg.gamersky.com/' },
  { name: '游民社区', url: 'http://club.gamersky.com/' }
]